import { z } from 'zod';

// Canonical Zod enum mirroring the Prisma TenantProductLine enum.
export const TenantProductLineEnum = z.enum(['CORE', 'COMP', 'CORE_AND_COMP']);
export type TenantProductLine = z.infer<typeof TenantProductLineEnum>;
